<div class="main">
    <app-header-section></app-header-section>
    <app-breadcrumb-explore-one></app-breadcrumb-explore-one>
    <app-explore-two-section></app-explore-two-section>
    <app-footer-section></app-footer-section>
    <app-modal-search></app-modal-search>
    <app-modal-menu></app-modal-menu>
    <app-scrollup></app-scrollup>
</div>
